import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleCourse = async (CourseID) => {
  try {
    const CoursesCollection = collection(db, "Courses");
    const CourseDocument = doc(CoursesCollection, CourseID);
    const CourseSnapshot = await getDoc(
      CourseDocument,
      where("IsDeleted", "==", false)
    );

    let Course = { ...CourseSnapshot.data(), id: CourseSnapshot.id };

    return Course;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleCourse;
